import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAvatar } from '@services/settings';
import { toast } from 'react-toastify';
import { USER_CURRENT_QUERY_KEY } from './useCurrentUser';
import { useTranslation } from '@hooks/useTranslation';

export const useUpdateAvatar = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (file: File) => updateAvatar(file),
    onSuccess: async () => {
      toast.success(tActionMessages.avatarUpdatedSuccessfully);
      await queryClient.invalidateQueries({ queryKey: USER_CURRENT_QUERY_KEY });
    },
    onError: (error: any) => {
      const message = error?.response?.errors?.[0]?.message || tActionMessages.requestError;
      toast.error(message);
    },
  });
};

export default useUpdateAvatar;
